<template>
    <div style="width: 100%; width: 100%">
        <h1 class="name">{{ name }}</h1>
        <transition mode="out-in" name="slide-fade">
            <div :key="name" v-if="list.length > 0">
                <div
                    class="item"
                    v-for="item in list"
                    :key="item.id + item.name"
                    @click="() => ss(item.id, item.name)"
                >
                    {{ item.name }}
                </div>
            </div>
            <div v-else class="item">
                Pas encore de cartes dans cette catégories :(
            </div>
        </transition>
        <transition name="slide-fade">
            <div class="item" @click="previous">Retour</div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "CardList",
    props: ["name", "list", "switchState", "previous"],
    methods: {
        ss: function(index, name) {
            if (this.name === "Toutes les catégories") {
                this.switchState({ new: "category", name: name });
            } else {
                this.switchState({ new: "card", id: index });
            }
        },
    },
};
</script>

<style scoped>
.name {
    font-style: italic;
    color: gray;
    font-size: 1.2em;
    text-indent: 0;
    text-transform: capitalize;
    font-weight: normal;
    margin: 0;
}

.item {
    color: black;
    font-weight: bold;
    border-bottom: 2px solid black;
    width: 100%;
    padding-top: 4vh;
    padding-bottom: 1vh;
    text-transform: capitalize;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
    transition: all 0.5s;
}
.slide-fade-leave-active {
    transition: all 0.3s;
}
.slide-fade-enter {
    transform: translateY(-20px) translateX(-10px);
}
.slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
